import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Typography, Chip, Box } from '@mui/material';
import { MoreVert as MoreIcon, Lock } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BUILT_IN_ROLES = new Set(['admin', 'super_admin', 'customer']);

const RolesTableRow = ({
    item,
    index = 0,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';
    const isArabic = lng.startsWith('ar');

    const isBuiltIn = BUILT_IN_ROLES.has(item.name);
    const label =
        item.label?.[lng] || item.label?.en || item.label?.ar || item.label;

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox checked={isSelected} onClick={(e) => onRowCheckboxClick(e, item.id)} />
            </TableCell>

            <TableCell align="start">{index + 1}</TableCell>

            {/* Name */}
            <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography
                        component={RouterLink}
                        to={`/settings/roles/${item.id}/edit`}
                        variant="body2"
                        fontWeight="bold"
                        sx={{ color: 'primary.main', textDecoration: 'none', fontFamily: 'monospace' }}
                    >
                        {item.name}
                    </Typography>
                    {isBuiltIn && (
                        <Chip
                            size="small"
                            icon={<Lock sx={{ fontSize: 12 }} />}
                            label={isArabic ? 'مدمج' : 'Built-in'}
                            color="default"
                            variant="outlined"
                            sx={{ fontSize: 10, height: 20 }}
                        />
                    )}
                </Box>
            </TableCell>

            {/* Label */}
            <TableCell>
                <Typography variant="body2">
                    {label || <Typography component="span" variant="caption" color="text.disabled">—</Typography>}
                </Typography>
            </TableCell>

            {/* Permissions count */}
            <TableCell align="center">
                <Chip
                    size="small"
                    label={item.permissions_count ?? item.permissions?.length ?? 0}
                    color="primary"
                    variant="tonal"
                    sx={{ fontWeight: 'bold', borderRadius: '6px', minWidth: 40 }}
                />
            </TableCell>

            {/* Users count */}
            <TableCell align="center">
                <Chip
                    size="small"
                    label={item.users_count ?? 0}
                    color={item.users_count > 0 ? 'success' : 'default'}
                    variant="tonal"
                    sx={{ fontWeight: 'bold', borderRadius: '6px', minWidth: 40 }}
                />
            </TableCell>

            {/* Guard */}
            <TableCell align="center">
                <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                    {item.guard_name || 'web'}
                </Typography>
            </TableCell>

            {/* Actions */}
            <TableCell align="center">
                <IconButton size="small" onClick={(e) => onMenuOpen(e, item)}>
                    <MoreIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default RolesTableRow;
